/** @typedef {'text' | 'full_bleed' | 'half_two_images' | 'half_one_image'} AuthorPageLayoutMode */

export const MAX_AUTHORED_BODY_WORDS = 240;
export const MAX_AUTHORED_HALF_PAGE_TEXT_WORDS = 120;
export const VISUAL_LAYOUT_FULL = 'full_page';
export const VISUAL_LAYOUT_HALF = 'half_page';

function coerceVisualUrlEntry(u) {
  if (typeof u === 'string' && /^https?:\/\//i.test(u)) return u;
  if (u && typeof u === 'object' && typeof u.url === 'string' && /^https?:\/\//i.test(u.url)) return u.url;
  return null;
}

/** URLs for pages — prefers API `visual_urls`, falls back to parsing `visual_content` (Python str(list)). */
export function normalizeAuthorPageVisualUrls(page) {
  if (!page) return [];
  const fromApi = page.visual_urls;
  if (fromApi != null) {
    if (Array.isArray(fromApi) && fromApi.length > 0) {
      const arr = fromApi.map(coerceVisualUrlEntry).filter(Boolean);
      if (arr.length > 0) return arr;
    }
    if (typeof fromApi === 'object' && !Array.isArray(fromApi)) {
      const arr = Object.keys(fromApi)
        .sort((a, b) => Number(a) - Number(b))
        .map((k) => coerceVisualUrlEntry(fromApi[k]))
        .filter(Boolean);
      if (arr.length > 0) return arr;
    }
  }
  const raw = page.visual_content;
  if (typeof raw !== 'string' || !raw.trim()) return [];
  const matches = raw.match(/https?:\/\/[^\s'"\],\]]+/g);
  return matches ?? [];
}

/**
 * @returns {{ layoutMode: AuthorPageLayoutMode, allowText: boolean, maxWords: number }}
 */
export function getAuthorPageTextPolicy(page, urls) {
  const layout = page?.visual_content_size;
  const n = urls.length;

  if (!page || n === 0) {
    return {
      layoutMode: 'text',
      allowText: true,
      maxWords: MAX_AUTHORED_BODY_WORDS,
    };
  }

  if (layout === VISUAL_LAYOUT_FULL) {
    return { layoutMode: 'full_bleed', allowText: false, maxWords: 0 };
  }

  if (layout === VISUAL_LAYOUT_HALF && n >= 2) {
    return { layoutMode: 'half_two_images', allowText: false, maxWords: 0 };
  }

  if (layout === VISUAL_LAYOUT_HALF && n === 1) {
    return {
      layoutMode: 'half_one_image',
      allowText: true,
      maxWords: MAX_AUTHORED_HALF_PAGE_TEXT_WORDS,
    };
  }

  return {
    layoutMode: 'text',
    allowText: true,
    maxWords: MAX_AUTHORED_BODY_WORDS,
  };
}
